import axios from "axios";

export const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API_URL });

api.interceptors.request.use((config) => {
  const token = window.localStorage.getItem("session_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  config.withCredentials = true;
  return config;
});

// Pages that must remain reachable when a user is trial-expired without a
// paid plan. Redirecting these back to /trial-expired would create a loop
// (or block the user from actually choosing a plan / seeing legal info).
const _ALLOWED_WHILE_EXPIRED = [
  "/trial-expired",
  "/pricing",
  "/checkout/",
  "/mi-suscripcion",
  "/mi-perfil",
  "/legal",
  "/login",
  "/auth/",
];

function _isAllowedRoute(pathname) {
  return _ALLOWED_WHILE_EXPIRED.some((prefix) => pathname === prefix || pathname.startsWith(prefix));
}

// Debounce so a burst of 402s from multiple in-flight requests only triggers
// one redirect.
let _redirecting = false;

// Global handler for 402 (trial expired / subscription required).
//
// BUSINESS RULE: a 402 from any premium action must ALWAYS land the user on
// the Plan Selection screen — never a blank page. We do BOTH:
//   1. Broadcast `mc:subscription-required` so the PaywallModal can show a
//      transient explanation.
//   2. Hard-navigate to /trial-expired unless the user is already on a
//      whitelisted route (pricing, checkout, profile, legal, auth).
api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 402) {
      window.dispatchEvent(new CustomEvent("mc:subscription-required", { detail: err.response.data?.detail }));
      const path = window.location.pathname || "/";
      if (!_isAllowedRoute(path) && !_redirecting) {
        _redirecting = true;
        // Preserve their intent as ?from= so /trial-expired can offer a
        // "come back here after paying" affordance later if we want it.
        const from = encodeURIComponent(path + (window.location.search || ""));
        window.location.assign(`/trial-expired?from=${from}`);
      }
    }
    return Promise.reject(err);
  },
);